import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { actions } from '../../../Slice/LoginSlice';
import Button from './Button';
import { ReactComponent as CrossIcon } from '../assets/img/icons/cross.svg';

const LoginWrapper = styled.div`
  margin: 0px;
  padding: 50px 60px;
  border-radius: 30px;
  background-color: #fff;
  display: block;
  width: 100%;
  position: relative;
  @media all and (max-width: 1439px),
    (max-height: 729px),
    (-webkit-device-pixel-ratio: 1.25) {
    border-radius: 21px;
    padding: 0px 40px 30px 40px;
    max-width: 400px;
  }
  .cross-btn {
    position: absolute;
    right: 18px;
    top: 20px;
    cursor: pointer;
    @media all and (max-width: 1439px),
      (max-height: 729px),
      (-webkit-device-pixel-ratio: 1.25) {
      top: 12px;
    }
    svg {
      @media all and (max-width: 1439px),
        (max-height: 729px),
        (-webkit-device-pixel-ratio: 1.25) {
        width: 23px;
        height: 23px;
      }
    }
  }
  .content-wrapper {
    margin-top: 75px;
    margin-bottom: 0px;
    h2 {
      margin-top: 30px;
      font-family: "Roboto Slab";
    }
  }
  .input-field-spacing {
    margin-top: 50px;
    margin-bottom: 70px;
    .title{
      font-size:50px;
      line-height:50px;
    }
  }
  h2 {
    color: #424b50;
    font-size: 54px;
    margin: 64px 0 10px 0;
    font-weight: bold;
    text-align: left;
    @media all and (max-width: 1439px),
      (max-height: 729px),
      (-webkit-device-pixel-ratio: 1.25) {
      font-size: 26px;
      margin: 25px 0 10px 0;
    }
  }

  p {
    font-size: 16px;
    color: #5e7079;
    margin: 27px 0;
    font-family: "Roboto";
    font-weight: 600;
    @media all and (max-width: 1439px),
      (max-height: 729px),
      (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
      margin: 16px 0;
    }
    a {
      color: #1EC252 !important;
      font-weight: 700;
      text-decoration: none;
    }
  }
  .title{
      width: 360px !important;
  }
`;
interface Props {
  setRedirectPath: (url: string) => void;
}
const PasswordReset: React.FC<Props> = function PasswordReset(props: Props) {
  const { setRedirectPath } = props;
  const dispatch = useDispatch();

  const redirectToMainScreen = () => {
    setRedirectPath('');
  };

  useEffect(() => {
    dispatch(actions.resetForgetPassword(false));
  }, []);
  return (
    <LoginWrapper>
      <Link to="/login" className="cross-btn" onClick={redirectToMainScreen}>
        <CrossIcon />
      </Link>
      <div className="content-wrapper">
        <div className="input-field-spacing">
          <h2 className="title">Password reset sent!</h2>
          <p>
            Check your email for our email containing your password reset instructions.
            Once you have it, you can use it to create a new password for your
            Sales Intelligence account.
          </p>
        </div>
      </div>

      <Button value="Ok, thanks" onClickButton={redirectToMainScreen} />
    </LoginWrapper>
  );
};

export default PasswordReset;
